module.exports = __webpack_public_path__ + "static/media/green-car.9b336369.svg";